export const large = '@media (min-width: 1200px)'
export const medium = '@media (min-width: 992px) and (max-width: 1199px)'
export const small = '@media (min-width: 600px) and (max-width: 992px)'
export const extraSmall = '@media (max-width: 600px)'